<template>
    <div class="page">
        <div class="baner-subpage">
            <div class="container">
                <div class="text">Judaszowce, lecz nie tylko ...</div>
            </div>
        </div>
        <div class="content">
            <div class="container">
                <h2 class="pageHeader text-center">
                    Judaszowce - Cercises
                </h2>
                <div class="cms text-center">
                    Na podstawie naszych kilkuletnich obserwacji i doświadczeń wypracowaliśmy najlepszy naszym zdaniem zestaw odmian Judaszowców do sadzenia w naszych, polskich ogrodach.
                    <br/><br/><br/>
                </div>

            </div>
        </div>
        <div class="judaszowce">
           <div class="container">
               <div class="item">
                   <div class="row align-items-center">
                       <div class="col-12 col-sm-5 col-md-4 col-lg-3">
                           <div class="img">
                               <img class="img-fluid" src="/static/img/judaszowce/judaszowce_1.jpg" alt="'RUBY FALLS'"/>
                           </div>
                       </div>
                       <div class="col-12 col-sm-7 col-md-8 col-lg-9 align">
                           <div class="text">
                               Judaszowiec kanadyjski <b>'RUBY FALLS'</b> Cercis canadensis 'Ruby Falls'.<br/>
                               Forma przewisająca, liście ciemno-buraczkowe, wysokość 2-2,5m. Kwiaty różowe.
                           </div>
                       </div>
                   </div>
               </div>
               <div class="item">
                   <div class="row align-items-center">
                       <div class="col-12 col-sm-5 col-md-4 col-lg-3">
                           <div class="img">
                               <img class="img-fluid" src="/static/img/judaszowce/judaszowce_2.jpg" alt="'LAVENDER TWIST'"/>
                           </div>
                       </div>
                       <div class="col-12 col-sm-7 col-md-8 col-lg-9 align">
                           <div class="text">
                               Judaszowiec kanadyjski <b>'LAVENDER TWIST'</b> - Cercis canadensis 'Lavender Twist'.<br/>
                               Wspaniała odmiana o przewisających pędach i zielonych liściach. Kwitnie bardzo obficie i jest bardzo odporna na mróz.
                           </div>
                       </div>
                   </div>
               </div>
               <div class="item">
                   <div class="row align-items-center">
                       <div class="col-12 col-sm-5 col-md-4 col-lg-3">
                           <div class="img">
                               <img class="img-fluid" src="/static/img/judaszowce/judaszowce_3.jpg" alt="'VANILLA TWIST'"/>
                           </div>
                       </div>
                       <div class="col-12 col-sm-7 col-md-8 col-lg-9 align">
                           <div class="text">
                               Judaszowiec kanadyjski <b>'VANILLA TWIST'</b> - Cercis canadensis 'Vanilla Twist'.<br/>
                               Mocna odmiana o przewisającej formie, zielonych, błyszczących liściach. Kwiaty białe, kwitnienie bardzo obfite.
                           </div>
                       </div>
                   </div>
               </div>
               <div class="item">
                   <div class="row align-items-center">
                       <div class="col-12 col-sm-5 col-md-4 col-lg-3">
                           <div class="img">
                               <img class="img-fluid" src="/static/img/judaszowce/judaszowce_4.jpg" alt="'THE RISING SUN'"/>
                           </div>
                       </div>
                       <div class="col-12 col-sm-7 col-md-8 col-lg-9 align">
                           <div class="text">
                               Judaszowiec kanadyjski <b>'THE RISING SUN'</b> - Cercis canadensis 'The Rising Sun'.<br/>
                               Nagrodzona srebrnym medalem w konkursie nowości (Zieleń to Zycie 2018rok) piękna odmiana o żółtych, wiosną pomarańczowych liściach. Kwiaty obfite, jasno-różowe.

                           </div>
                       </div>
                   </div>
               </div>
               <div class="item">
                   <div class="row align-items-center">
                       <div class="col-12 col-sm-5 col-md-4 col-lg-3">
                           <div class="img">
                               <img class="img-fluid" src="/static/img/judaszowce/judaszowce_5.jpg" alt="'APPALACHIAN RED'"/>
                           </div>
                       </div>
                       <div class="col-12 col-sm-7 col-md-8 col-lg-9 align">
                           <div class="text">
                               Judaszowiec kanadyjski <b>'APPALACHIAN RED'</b>  - Cercis canadensis 'Appalachian Red'.<br/>
                               Odmiana o najpiękniejszych kwiatach, kwitnienie bardzo obfite. Wysokość ok. 3m.

                           </div>
                       </div>
                   </div>
               </div>
               <div class="item">
                   <div class="row align-items-center">
                       <div class="col-12 col-sm-5 col-md-4 col-lg-3">
                           <div class="img">
                               <img class="img-fluid" src="/static/img/judaszowce/judaszowce_6.jpg" alt="'FOREST PANSY'"/>
                           </div>
                       </div>
                       <div class="col-12 col-sm-7 col-md-8 col-lg-9 align">
                           <div class="text">
                               Judaszowiec kanadyjski <b>'FOREST PANSY'</b>  - Cercis canadensis 'Forest Pansy'.<br/>
                               Jedna z pierwszych odmian judaszowców, ciemne liście, dobra mrozoodporność.
                           </div>
                       </div>
                   </div>
               </div>
               <div class="item">
                   <div class="row align-items-center">
                       <div class="col-12 col-sm-5 col-md-4 col-lg-3">
                           <div class="img">
                               <img class="img-fluid" src="/static/img/judaszowce/judaszowce_7.jpg" alt="'HEARTS OF GOLD'"/>
                           </div>
                       </div>
                       <div class="col-12 col-sm-7 col-md-8 col-lg-9 align">
                           <div class="text">
                               Judaszowiec kanadyjski <b>'HEARTS OF GOLD'</b> - Cercis canadensis 'Hearts of Gold'.<br/>
                               Piękna odmiana o żółtych liściach, 3-4 metry wysokości.
                           </div>
                       </div>
                   </div>
               </div>
               <div class="item">
                   <div class="row align-items-center">
                       <div class="col-12 col-sm-5 col-md-4 col-lg-3">
                           <div class="img">
                               <img class="img-fluid" src="/static/img/judaszowce/judaszowce_8.jpg" alt="'ALLEY CAT'"/>
                           </div>
                       </div>
                       <div class="col-12 col-sm-7 col-md-8 col-lg-9 align">
                           <div class="text">
                               Judaszowiec kanadyjski <b>'ALLEY CAT'</b> - Cercis canadensis 'Alley Cat'.<br/>
                               Nowa odmiana charakteryzująca się białymi przebarwieniami na liściach. Kwitnienie bardzo obfite.
                           </div>
                       </div>
                   </div>
               </div>
               <div class="item">
                   <div class="row align-items-center">
                       <div class="col-12 col-sm-5 col-md-4 col-lg-3">
                           <div class="img">
                               <img class="img-fluid" src="/static/img/judaszowce/judaszowce_9.jpg" alt="'CAROLINA SWEETHEART'"/>
                           </div>
                       </div>
                       <div class="col-12 col-sm-7 col-md-8 col-lg-9 align">
                           <div class="text">
                               Judaszowiec kanadyjski <b>'CAROLINA SWEETHEART'</b> - Cercis canadensis 'Carolina Sweetheart'.<br/>
                               Ciemne liście tej nowej odmiany, w drugiej połowie lata przebarwiają się bajecznie tworząc kremowo-różowe mozaikowe obwódki.

                           </div>
                       </div>
                   </div>
               </div>
               <div class="item">
                   <div class="row align-items-center">
                       <div class="col-12 col-sm-5 col-md-4 col-lg-3">
                           <div class="img">
                               <img class="img-fluid" src="/static/img/judaszowce/judaszowce_10.jpg" alt="'PINK POM POMS'"/>
                           </div>
                       </div>
                       <div class="col-12 col-sm-7 col-md-8 col-lg-9 align">
                           <div class="text">
                               Judaszowiec kanadyjski <b>'PINK POM POMS'</b> - Cercis canadensis 'Pink Pom Poms'.<br/>
                               Ozdobą tej nowej odmiany są znacznie większe niż u innych odmian, do tego pełne kwiaty. Liście błyszczące, zielone.

                           </div>
                       </div>
                   </div>
               </div>
           </div>


        </div>
    </div>


</template>

<script>

    import 'owl.carousel/dist/owl.carousel.js'
    import 'owl.carousel/dist/assets/owl.carousel.min.css'
    import 'owl.carousel/dist/assets/owl.theme.default.min.css'
    import '../../static/plugins/venobox/venobox.css'
    import '../../static/plugins/venobox/venobox.js'
    export default {
        components: {



        },
        methods: {

        },
        mounted: function () {


        }
    }



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Judaszowce.vue